import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AppState } from '../../../core';
import { ScoutTaskDoc } from '../../../core/schema/scout-task-schema';
import {  ScoutPointPhotoService, ScoutPointPhotoUploadService, ScoutTaskService } from '../../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ScoutPath, MapImageOverlay } from '../../../core/models';
import { MapImageOverlayComponent } from '../../../shared/mapping/map-image-overlay/map-image-overlay.component';


@Component({
  selector: 'app-scout-path-overlay',
  templateUrl: '../../../shared/mapping/map-image-overlay/map-image-overlay.component.html',
  styleUrls: ['../../../shared/mapping/map-image-overlay/map-image-overlay.component.scss']
})
export class ScoutPathOverlayComponent  extends MapImageOverlayComponent implements OnInit, OnDestroy {

  @Input() scoutTaskDoc : ScoutTaskDoc
  @Input() set scoutPath (sp : ScoutPath ){
    this._scoutPath = sp
    this.initFormValues()
  }
  get scoutPath() { return this._scoutPath }
  _scoutPath : ScoutPath
   

  constructor( appState: AppState, 
      public scoutTaskService : ScoutTaskService,
      photoService : ScoutPointPhotoService,
      photoUploadService : ScoutPointPhotoUploadService,
      modalService : BsModalService ) { 
    super(appState,photoService,photoUploadService,modalService)
  }
  

  ngOnInit() : void {
    this.subscribe( this.scoutTaskDoc.get$('scoutPaths'), scoutPaths => this.initFormValues() )
    super.ngOnInit()
  }

  getOwnerId(): string {
    return this.scoutPath.id
  }
  
  getSharableOverlays(): { ownerId: string; ownerIndex: number; overlay: MapImageOverlay; }[] {
    if ( this.scoutPath ) {
      const pathOverlayDefs = this.scoutTaskDoc?.scoutPaths?.map((path,index)=>{ return { ownerId:path.id,ownerIndex:index,overlay:path.overlay } })
      const otherOverlayDefs = pathOverlayDefs.filter(def=>def.ownerId!=this.scoutPath.id)
      return otherOverlayDefs.filter(def=>def.overlay?.imageId&&def.overlay?.pixelSize?.width)
    } else { 
      return null
    }
  }

  async saveOverlay(overlay: MapImageOverlay) {
    let oldImageId : string = null
    await this.scoutTaskDoc.atomicUpdate( (taskDoc) => {
      let scoutPath = taskDoc.scoutPaths?.find(sp=>sp.id==this.scoutPath.id)
      this.scoutTaskService.assignWhoAndWhenForPath(scoutPath)          
      oldImageId = scoutPath.overlay?.imageId
      scoutPath.overlay = overlay
      return taskDoc
    })
    this._scoutPath = this.scoutTaskDoc?.scoutPaths.find(sp=>sp.id==this.scoutPath.id)
    return oldImageId
  }

}
